module.exports = __webpack_public_path__ + "static/img/buyersearchbg.c30856d2.png";